import React, { Component } from "react";
/*import { connect } from "react-redux";*/
/*import { updateCart, removeFromCart, saveCart } from "../actions/cartActions";*/
import { utils } from "../common/utils";
/*import { withTranslation } from 'react-i18next';*/
import ExtendedLink from "../components/ExtendedLink";
import Image from "../components/Image";
import CurrencyFormat from './CurrencyFormat';

class MenuCartLine extends Component {

    render() {
        const { line, settings } = this.props;
        if (!line) return <div />;
        const { product } = line;
        const productLink = `/products/${product.id}`;


        return (<div className="dropdown-product-item">
            <button onClick={this.props.onRemoveLine} className="dropdown-product-remove btn btn-link">
                <i className="icon-cross" />
            </button>
            <ExtendedLink to={productLink} className="dropdown-product-thumb">
                <Image src={product.thumbnail ? product.thumbnail : "img/no-image.jpg"}
                    fallbackSrc="img/no-image.jpg" alt={product.title} />
            </ExtendedLink>
            <div className="dropdown-product-info">
                <ExtendedLink to={productLink} className="dropdown-product-title">
                    {product.title}
                </ExtendedLink>
                <span className="dropdown-product-details">
                    {line.quantity} x <CurrencyFormat value={product.specialPrice} settings={settings} />
                    {/*{utils.formatCurrency(product.specialPrice)}*/}
                </span>
            </div>
        </div>);
    }
}
export default MenuCartLine;
//function mapStateToProps({cart, user, settings }, ownProps) {
//    return { cart,user,  settings, ...ownProps };
//}

//export default withTranslation()(connect(mapStateToProps, null)(MenuCartLine));
